import { AppealSupportingDocumentType } from "@/__generated__/graphql";

export const documentTypeDisplayValueMap: Record<
  AppealSupportingDocumentType,
  string
> = {
  [AppealSupportingDocumentType.NoticeOfBenefitChange]:
    "Notice of Benefit Change",
  [AppealSupportingDocumentType.DenialLetter]: "Denial Letter",
  [AppealSupportingDocumentType.LetterOfMedicalNecessity]:
    "Letter of Medical Necessity",
  [AppealSupportingDocumentType.CoverLetter]: "Cover Letter",
  [AppealSupportingDocumentType.LabResults]: "Lab Results",
  [AppealSupportingDocumentType.MedicalRecords]: "Medical Records",
  [AppealSupportingDocumentType.InsuranceForm]: "Insurance Form",
  [AppealSupportingDocumentType.PatientConsent]: "Patient Consent",
  [AppealSupportingDocumentType.Other]: "Other/Not listed",
  [AppealSupportingDocumentType.InsuranceCard]: "Insurance Card",
};
